// @flow @jsx h

/* eslint-disable compat/compat */

import { h } from 'preact'
import PureComponent from 'preact-pure-component'
import style from './index.css'
import Section from './Section'

type Props = any

type State = any

class Content extends PureComponent<Props, State> {
  intersectionObserver: IntersectionObserver
  sectionElms: Array<HTMLElement | null>
  triggerElms: Array<Array<HTMLElement | null> | null>

  constructor (props: Props) {
    super(props)
    this.sectionElms = props.sections.map(section => null)
    this.triggerElms = props.sections.map(section => {
      switch (section.type) {
        case 'section':
          return section.value.content
            ? section.value.content.map(item => null)
            : []

        default:
          return null
      }
    })
    this.state = {
      sectionIntersections: props.sections.map(section => ({
        isIntersecting: false,
        intersectionRatio: 0
      })),
      triggerIntersections: props.sections.map(section => {
        switch (section.type) {
          case 'section':
            return section.value.content
              ? section.value.content.map(item => ({
                intersectionRatio: -1,
                isIntersecting: false
              }))
              : []

          default:
            return null
        }
      })
    }
  }

  componentDidMount () {
    this.intersectionObserver = new IntersectionObserver(
      entries => {
        entries.forEach(entry => {
          let sectionIndex = -1
          let index = -1

          // Find indexes
          this.triggerElms.forEach((triggerElms, idx) => {
            if (triggerElms) {
              const triggerIndex = triggerElms.indexOf(entry.target)

              if (triggerIndex > -1) {
                sectionIndex = idx
                index = triggerIndex
              }
            }
          })

          // Update triggerIntersections
          if (index > -1) {
            const triggerIntersections = this.state.triggerIntersections.slice(
              0
            )

            if (triggerIntersections[sectionIndex]) {
              const intersections = triggerIntersections[sectionIndex].slice(0)

              intersections[index] = {
                isIntersecting: entry.isIntersecting,
                intersectionRatio: entry.intersectionRatio
              }

              triggerIntersections[sectionIndex] = intersections
            }

            this.setState({ triggerIntersections })

            return
          }

          sectionIndex = this.sectionElms.indexOf(entry.target)

          // Update sectionIntersections
          if (sectionIndex > -1) {
            const sectionIntersections = this.state.sectionIntersections.slice(
              0
            )

            sectionIntersections[sectionIndex] = {
              isIntersecting: entry.isIntersecting,
              intersectionRatio: entry.intersectionRatio
            }

            this.setState({ sectionIntersections })
          }
        })
      },
      {
        rootMargin: '0px 0px 0px 0px',
        threshold: [0, 0.5]
      }
    )

    // Observe intersection of section elements
    this.sectionElms.forEach(sectionElm => {
      if (sectionElm) {
        this.intersectionObserver.observe(sectionElm)
      }
    })

    // Observe intersections of trigger elements
    this.triggerElms.forEach(triggerElms => {
      if (triggerElms) {
        triggerElms.forEach(triggerElm => {
          if (triggerElm) {
            this.intersectionObserver.observe(triggerElm)
          }
        })
      }
    })
  }

  handleRegisterSectionElement = (
    sectionElm: HTMLElement,
    sectionIndex: number
  ) => {
    this.sectionElms[sectionIndex] = sectionElm
  }

  handleRegisterTriggerElement = (
    triggerElm: HTMLElement,
    sectionIndex: number,
    index: number
  ) => {
    if (this.triggerElms[sectionIndex]) {
      this.triggerElms[sectionIndex][index] = triggerElm
    }
  }

  render () {
    const {
      mediaBaseUrl,
      muted,
      onAnalyticsEvent,
      onUserToggleMute,
      sections,
      viewport
    } = this.props
    const { sectionIntersections, triggerIntersections } = this.state

    return (
      <div className={style.article__content}>
        {sections.map((section, idx) => {
          switch (section.type) {
            case 'section':
              return (
                <Section
                  {...section}
                  {...sectionIntersections[idx]}
                  key={String(idx)}
                  index={idx}
                  intersections={triggerIntersections[idx]}
                  mediaBaseUrl={mediaBaseUrl}
                  muted={muted}
                  onAnalyticsEvent={onAnalyticsEvent}
                  onUserToggleMute={onUserToggleMute}
                  onRegisterSectionElement={this.handleRegisterSectionElement}
                  onRegisterTriggerElement={this.handleRegisterTriggerElement}
                  viewport={viewport}
                />
              )

            default:
              return null
          }
        })}
      </div>
    )
  }
}

export default Content



// WEBPACK FOOTER //
// ./src/v1/components/Article/Content.js